import { useMemo } from 'react';
import { capitalize } from 'lodash';
import { i18n as I18n } from '../../../utils/i18n';

interface Filters {
  location: string | null;
  roomTypes: Array<string>;
}

const formatLocation = location => {
  return location.split(' ').map(capitalize).join(' ');
};

const useHeader = (filters: Filters) => {
  const header = useMemo(() => {
    if (filters.location === null || filters.location === '') {
      if (filters.roomTypes.length === 1) {
        return {
          title: I18n.t('headers.no_location_one_room_type.title', {
            roomType: filters.roomTypes[0],
          }),
          description: I18n.t('headers.no_location_one_room_type.description', {
            roomType: filters.roomTypes[0],
          }),
        };
      }

      if (filters.roomTypes.length > 1) {
        return {
          title: I18n.t('headers.no_location_many_room_types.title'),
          description: I18n.t(
            'headers.no_location_many_room_types.description'
          ),
        };
      }
    }

    if (filters.location) {
      if (filters.roomTypes.length === 1) {
        return {
          title: I18n.t('headers.one_location_one_room_type.title', {
            roomType: filters.roomTypes[0],
            location: formatLocation(filters.location),
          }),
          description: I18n.t(
            'headers.one_location_one_room_type.description',
            {
              roomType: filters.roomTypes[0],
              location: formatLocation(filters.location),
            }
          ),
        };
      }

      return {
        title: I18n.t('headers.one_location_many_room_types.title', {
          location: formatLocation(filters.location),
        }),
        description: I18n.t(
          'headers.one_location_many_room_types.description',
          {
            location: formatLocation(filters.location),
          }
        ),
      };
    }

    return {
      title: I18n.t('headers.no_filters_rooms_search_page.title'),
      description: I18n.t('headers.no_filters_rooms_search_page.description'),
    };
  }, [filters.location, filters.roomTypes]);

  return header;
};

export default useHeader;
